/**------------- Used Car Card constants -------------**/

/*  General  */
export const USED_CAR_CARD_CLASS_NAME = "used-car-card";
export const USED_CAR_CARD_TYPE = "button";

/*  Image  */
export const USED_CAR_CARD_PRESENTATION_IMAGE_CONTAINER_CLASS_NAME =
	"used-car-card-image-container";
export const USED_CAR_CARD_PRESENTATION_IMAGE_ALT =
	"used-car-image";

/*  Overview  */
export const USED_CAR_CARD_OVERVIEW_FLEX_CONTAINER_CLASS_NAME =
	"used-car-card-overview-flex";

/*  Price  */
export const USED_CAR_CARD_PRICE_CONTAINER_CLASS_NAME =
	"used-car-card-price-container";

/*  Fallback  */
export const USED_CARS_UNAVAILABLE_IMAGE_DESCRIPTION =
	"Anteprima non disponibile.";
